import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const CountParamsTypeSelect = observer(({ store, disabled = false }) => {
  return (<>
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={store?.options()}
        //defaultValue={store?.selectedCountParameters ? store?.selectedCountParameters : []}
        value={store?.selectedCountParameters.map((param) => ({label: param.label, uuid: param.uuid}))}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.uuid}
        onChange={(data) => store?.selectParameters(data, "selectedCountParameters")}
        placeholder="Select"
        isMulti
        isDisabled={disabled}
      />
    </>
  );
});

export default CountParamsTypeSelect;
